<div class="uk-inline" *ngIf="(state | async)[component].count !== null">
  <ng-container i18n="@@Selected">Selected: </ng-container>
  <span [ngClass]="{ selected: (state | async).selected > 0 }">{{ (state | async).selected }}</span>
</div>
